import React from 'react';
import { ISimpleBaseChart } from '../SimpleChartEngine/types';
import { cn } from '@/lib/utils';
import { TrendingDown, TrendingUp } from 'lucide-react';

interface IProps extends Pick<ISimpleBaseChart, 'title' | 'description' | 'className' | 'trend' | 'compact'> {
  children: React.ReactNode;
}
export const SimpleChartCardWrapper: React.FC<IProps> = (props: IProps) => {
  const {
    title,
    description,
    className,
    children,
    trend,
    compact,
  } = props;

  const hasCardWrapper = title || description || trend;

  if (!hasCardWrapper) {
    return children;
  }

  return (
    <div className={cn("w-full bg-secondary/8 rounded-lg p-3", className)}>
      <div className="flex flex-col gap-1 mb-2">
        {title && (
          <p className={cn("font-semibold leading-none tracking-tight", compact ? "text-sm" : "text-base")}>
            {title}
          </p>
        )}
        {description && (
          <p className={cn("text-muted-foreground", compact ? "text-xs" : "text-sm")}>
            {description}
          </p>
        )}
        {trend && (
          <div className="flex items-center gap-2 text-sm">
            {trend.direction === 'up' ? (
              <TrendingUp className="h-4 w-4 text-card-ok-text" />
            ) : (
              <TrendingDown className="h-4 w-4 text-card-error-text" />
            )}
            <span className={cn(
              "font-medium",
              trend.direction === 'up' ? "text-card-ok-text" : "text-card-error-text"
            )}>
              {trend.text}
            </span>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
